import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import EuReadinessMedtechEs from "@/pages/EuReadinessMedtechEs";

export const Route = createFileRoute("/es/eu-readiness-medtech")({
  head: () => buildRouteHead("/es/eu-readiness-medtech"),
  component: EuReadinessMedtechEs,
});

